<template>
	<div class="page-transition-viewport">
		<router-view v-slot="{ Component, route }">
			<transition name="page-transition" mode="out-in" :duration="500">
				<component :is="Component" :key="route.path" />
			</transition>
		</router-view>
	</div>
</template>

<script src="./Content.js"></script>
<style src="../../transitions/Page/Page.scss" lang="scss"></style>
